'use strict';
var localisations = require('./admin.localisations');

export default class AllgroupsController {
  /*@ngInject*/
  constructor(User, common, groups, $mdBottomSheet, $location, Auth, $timeout) {
    var that = this;
    this.isAdmin = Auth.isAdminSync;
    this.common = common;
    this.common.setBack(null, null);
    this.$location = $location;
    this.localisations = localisations[this.common.getLocale()];
    this.$mdBottomSheet = $mdBottomSheet;
    this.$timeout = $timeout;
    this.groups = groups;
    that.groups.initialise(function(data){
      console.log('Got Groups', that.groups.getGroups());
      common.setLoading(false);
    }, function(){
      common.setLoading(false);
    });
    this.newGroupUsers = [];
    this.high = 18;
    this.low = 12;
    this.showGroupList = false;
    this.groupingUser = '';
    this.showingDetails = '';
    this.expandedGroup = '';
    this.newGroupName = '';
    this.globalSettings = this.groups.getGlobalSettings();
  }

  updateGlobalSettings() {
    this.$timeout(() => {
      console.log('GlobalSetting:', this.globalSettings);
      this.groups.updateGlobalSettings(this.globalSettings, function() {}, function() {});
    }, 500);
  }

  setShownGroup(id) {
    if(this.expandedGroup == id) {
      this.expandedGroup = '';
    } else {
      this.expandedGroup = id;
    }
  }

  showThisGroup(id) {
    return this.expandedGroup == id;
  }

  showUserDetails(e, id) {
    e.preventDefault();
    e.stopPropagation();
    if(this.showingDetails == id) {
      this.showingDetails = '';
    } else {
      this.showingDetails = id;
    }
  }

  addUserToGroup(e, user) {
    e.stopPropagation();
    e.preventDefault();
    this.showGroupList = true;
    this.groupingUser = user;
  }

  closeGroupList() {
    this.showGroupList = false;
    this.groupingUser = '';
  }

  addToGroup($event, group) {
    var that = this;
    console.log('ADDING', this.groupingUser, 'to', group);
    this.groups.addPersonToGroup(group, this.groupingUser, function(){
      that.closeGroupList();
    }, function() {});
  }

  goToGroupDiscussion(id) {
    this.$location.path(`/messages/${id}`);
  }

  addUserToNewGroup(id) {
    var thisIndex = this.newGroupUsers.indexOf(id);
    if(thisIndex < 0) {
      this.newGroupUsers.push(id);
    } else {
      this.newGroupUsers.splice(thisIndex, 1);
    }
  }

  removeUserFromGroup(e, userId, groupId){
    e.preventDefault();
    e.stopPropagation();
    this.groups.removeUserFromGroup(userId, groupId, function(){}, function(){});
  }

  createNewGroup() {
    var that = this;
    this.groups.createNewGroup({
      active: true,
      _users: this.newGroupUsers,
      name: this.newGroupName
    }, function() {
      console.log('Success Callback removing actives');
      that.newGroupUsers = [];
      console.log('Done', that.newGroupUsers);
    }, function() {
    });
  }

  saveGroupMeta(gid) {
    console.log('Saving additions', gid);
    this.groups.saveGroupUpdate(gid);
  }

  userInNewList(id) {
    return this.newGroupUsers.indexOf(id) > -1;
  }

  showTopicEntry(group) {
    this.groups.setCurrentGroup(group);
    console.log(group);
    this.$mdBottomSheet.show({
      template: require('./allgroups.bottomsheet.html'),
      controller: 'allgroupsBottomSheetCtrl',
      isLockedOpen: true
    });
  }
}



// WEBPACK FOOTER //
// ./client/app/admin/allgroups.controller.js